export default "__VITE_ASSET__c71f83f3__"